<div class="tab-content">
  <h2 class="admin-subsubheader">Bildergalerie bearbeiten</h2>
  <p class="admin-text">An dieser Stelle können sowohl neue Bilder hochgeladen als auch bereits hochgeladene Bilder
    bearbeitet werden. Damit Bilder in der Galerie angezeigt werden, muss das Häkchen bei "Bild anzeigen?"
    gesetzt sein. Um ein Bild in der Vorschau anzuzeigen, muss das Häkchen bei "Als Vorschau?" gesetzt sein.
  </p>
</div>

<div class="filter-row">

  <form class="example-form">
    <mat-form-field appearance="outline">
      <mat-label>Schlagwörter filtern</mat-label>

      <input matInput [formControl]="tagControl" [matAutocomplete]="tags" (input)="applyTagFilter($event)"
        placeholder="Schlagwort filtern" />

      <mat-autocomplete #tags="matAutocomplete" (optionSelected)="applyTagFilter($event)">
        @for(tag of filteredTags | async; track $index) {
        <mat-option [value]="tag">
          {{ tag }}
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </form>
</div>

<table mat-table [dataSource]="images" matSort class="custom-elevation-z8">
  <!-- Bild Vorschau -->
  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef> Bild </th>
    <td class="image-column" mat-cell *matCellDef="let image">
      @if(!image.isPlaceholder) {
      @let url = imageGalleryFolder + image.uuid + '/' + imageGalleryFileName;
      <img [src]="url" class="preview-img" />
      } @else {
      @let url = "/assets/placeholder-image.png";
      <img [src]="url" class="preview-img" />
      }
    </td>
  </ng-container>

  <!-- Tags Bearbeiten -->
  <ng-container matColumnDef="tags">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Schlagwörter </th>
    <td mat-cell *matCellDef="let image">
      @if(!image.isPlaceholder) {
      <mat-chip-listbox>
        @for (tag of image.tags; track $index) {
        <mat-chip (removed)="removeTag(image, tag)">
          {{ tag }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
        }
      </mat-chip-listbox>
      <input [(ngModel)]="image.newTag" (keydown.enter)="addTag(image, image.newTag)"
        placeholder="Schlagwort hinzufügen" />
      }
    </td>
  </ng-container>

  <!-- Als Thumbnail anzeigen -->
  <ng-container matColumnDef="showAsThumbnail">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Als Vorschau? </th>
    <td mat-cell *matCellDef="let image">
      @if(!image.isPlaceholder) {
      <mat-slide-toggle [(ngModel)]="image.showAsThumbnail" (change)="updateShowAsThumbnail(image)"></mat-slide-toggle>
      }
    </td>
  </ng-container>

  <!-- In Galerie anzeigen -->
  <ng-container matColumnDef="showInGallery">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Bild anzeigen? </th>
    <td mat-cell *matCellDef="let image">
      @if(!image.isPlaceholder) {
      <mat-slide-toggle [(ngModel)]="image.showInGallery" (change)="updateShowInGallery()"
        [disabled]="image.showAsThumbnail"></mat-slide-toggle>
      }
    </td>
  </ng-container>


  <!-- Löschen Button -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Aktion </th>
    <td mat-cell *matCellDef="let image">
      @if (image.isPlaceholder) {

      <button mat-mini-fab (click)="uploadImage(image)">
        <mat-icon class="admin-success">upload</mat-icon>
      </button>

      } @else {

      <button mat-mini-fab (click)="deleteImage(image)">
        <mat-icon class="error">delete</mat-icon>
      </button>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

<div class="button-container" [ngClass]="{'hasChanges': hasChanges()}">
  <button (click)="cancel()" mat-raised-button>Abbrechen</button>
  <button (click)="confirm()" [disabled]="!hasChanges()" mat-flat-button>Speichern</button>
</div>